import { useEmployeeEngagementDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/store/employeeEngagement.store';
import { KpiStatCardProps } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard';
import { isSelectionCleared } from 'pages/ReportsPage/store/analyticsSelection.utils';
import { useAnalyticsFilterStore } from 'pages/ReportsPage/store/analyticsFilterView.context';
import { buildClearedCard } from 'pages/ReportsPage/components/AnalyticsDashboards/kpiCardBuilders';

function pct(part: number, total: number): string {
  if (total === 0) return '0%';
  return `${Math.round((part / total) * 100)}%`;
}

export function useEmployeeEngagementKpiCards(): KpiStatCardProps[] {
  const locationIds = useAnalyticsFilterStore((s) => s.locationIds);
  const positions = useAnalyticsFilterStore((s) => s.positions);
  const total = useEmployeeEngagementDashboardStore((s) => s.totalTeamMembers);
  const fullTime = useEmployeeEngagementDashboardStore((s) => s.fullTimeMembers);
  const partTime = useEmployeeEngagementDashboardStore((s) => s.partTimeMembers);
  const smartphone = useEmployeeEngagementDashboardStore((s) => s.smartphoneAppUsers);
  const casual = useEmployeeEngagementDashboardStore((s) => s.casualMembers);
  const flex = useEmployeeEngagementDashboardStore((s) => s.flexMembers);

  const cards: KpiStatCardProps[] = [
    {
      label: 'Total Team Members',
      value: total.toLocaleString(),
      subtitle: 'Across all units and employment types',
    },
    {
      label: 'Full-Time Team Members',
      value: fullTime.toLocaleString(),
      subtitle: `${pct(fullTime, total)} of total workforce`,
    },
    {
      label: 'Part-Time Team Members',
      value: partTime.toLocaleString(),
      subtitle: `${pct(partTime, total)} of total workforce`,
    },
    {
      label: 'Smartphone App Users',
      value: smartphone.toLocaleString(),
      subtitle: `${pct(smartphone, total)} of total workforce`,
    },
    {
      label: 'Casual Team Members',
      value: casual.toLocaleString(),
      subtitle: `${pct(casual, total)} of total workforce`,
    },
    {
      label: 'Flex Team Members',
      value: flex.toLocaleString(),
      subtitle: `${pct(flex, total)} of total workforce`,
    },
  ];

  return isSelectionCleared(locationIds, positions)
    ? cards.map((card) => buildClearedCard(card.label))
    : cards;
}
